export const POST_SIGNUP_DETAILS_REQUEST = "POST_SIGNUP_DETAILS_REQUEST"
export const POST_SIGNUP_DETAILS_SUCCESS = "POST_SIGNUP_DETAILS_SUCCESS"
export const POST_SIGNUP_DETAILS_FAILURE = "POST_SIGNUP_DETAILS_FAILURE"

export const GET_LOGIN_DETAILS_REQUEST = "GET_LOGIN_DETAILS_REQUEST"
export const GET_LOGIN_DETAILS_SUCCESS = "GET_LOGIN_DETAILS_SUCCESS"
export const GET_LOGIN_DETAILS_FAILURE = "GET_LOGIN_DETAILS_FAILURE"

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT = "LOGOUT";

// export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
// export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
// export const GET_USERS_FAILURE = "GET_USERS_FAILURE";